import { useCallback } from 'react'
import { dynamicTemplate } from '@Util/dynamic-template'

import './styles.scss'

const CLASS_NAME = 'gby-k2g-animation-awaiting-next-draw-countdown'

export type AwaitingNextDrawCountdownProps = {
  drawingNumber: number
  latestDraw: number
}

export const AwaitingNextDrawCountdown = (props: AwaitingNextDrawCountdownProps) => {
  const bodyTemplate = useCallback(() => {
    const templateStr =
      'Time is still ticking! Your drawing <%= currentDrawNumber %> is <%= drawsAway %> draws away.'
    return dynamicTemplate(templateStr, {
      currentDrawNumber: props.drawingNumber,
      drawsAway: props.drawingNumber - props.latestDraw,
    })
  }, [props])

  return (
    <div className={`${CLASS_NAME}`}>
      <div className={`${CLASS_NAME}__text`} dangerouslySetInnerHTML={{ __html: bodyTemplate() }} />
      <img className={`${CLASS_NAME}__image`} src="/icons/awaiting-next-draw.png" />
    </div>
  )
}
